import React from 'react';
import { useState } from 'react';
import youPay from './Images/Group3722.svg';
import youGet from './Images/Group3725.svg';
import insurerPic from './Images/HDFC_Life_Logo.svg.png';
import PlanFeatures from './PlanFeatures';
import { convertIntoLakh, CommaSeprator, CountYear, decimaNumberFormat, isBeforeSep22_2025 } from './UtilityComponents/UtilityFunction';
import CircleLoader from './UtilityComponents/CircleLoader';
import crossBtn from '../Investment/Cross.svg';
const InvestmentPlanDetalis = ({ QuoteData, ClosePopup, BuyNow }) => {
    const [loader, setLoader] = useState(false);

    return (
        <>
            <div className="InvestmentDetalisMainPage">
                <div className="InvestmentDetalisPage">
                    <section>
                        <div className="InvestmentCardTop">
                            <div className="InsurerLogo">
                                <img src={QuoteData?.Image} className="IconPics" alt="Insurer Logo" />
                            </div>
                            <div className="InsurerPlanName">
                                <span className="SanchayPlus">{QuoteData?.PlanName}</span>
                            </div>
                            <div onClick={() => ClosePopup(false)} className="closebutton">
                                {/*<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" ><path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"></path></svg>*/}
                                <img src={crossBtn} alt="" />
                            </div>
                        </div>
                    </section>

                    <hr />

                    <section className="InvestmentPlanDetalis">
                        <div className="InvestEditPlan">
                            <div>
                                <img src={youPay} className="IconPic" />
                                <p className="YouGet">You pay</p>
                            </div>
                            <div className="EditProgrss">
                                <span className="YouGetText">₹{convertIntoLakh(parseInt(QuoteData?.TatalInvestmentAmount))} </span>
                            </div>
                            <div className="EditProgressBar">
                                <span className="investEditText">till {CountYear(QuoteData?.PaymentTerm)}</span>
                            </div>
                        </div>
                    </section>


                    <section className="InvestmentPlanDetalis">
                        <div className="InvestEditPlan">
                            <div>
                                <img src={youGet} className="IconPic" />
                                <p className="YouGet">You get</p>
                            </div>

                            <div className="EditProgress">
                                <span className="YouGetText">₹{convertIntoLakh(parseInt(QuoteData?.MaturityBenefit))} </span>
                            </div>

                            <div className="EditProgressBar">
                                <span className="investEditText">on {CountYear(QuoteData?.PolicyTerm)}</span>
                            </div>
                        </div>
                    </section>


                    <section className="InvestmentPlanDetalis">
                        <PlanFeatures />

                        <div className="PlanFeaturess">
                            <h3 className="InvestPopHead">Benefits</h3>
                            <div className="BenefitsDetails">
                                <span className="InvestTotal">Total investment amount</span>
                                <span className="InvestTotal">₹{CommaSeprator(decimaNumberFormat(QuoteData?.TatalInvestmentAmount))}</span>
                            </div>
                            <div className="BenefitsDetails">
                                <span className="InvestTotal">Investment duration</span>
                                <span className="InvestTotal">{QuoteData?.PaymentTerm} years (till {CountYear(QuoteData?.PaymentTerm)})</span>
                            </div>
                            <div className="BenefitsDetails">
                                <span className="InvestTotal">Maturity duration</span>
                                <span className="InvestTotal">{QuoteData?.PolicyTerm} years (in {CountYear(QuoteData?.PolicyTerm)})</span>
                            </div>
                            <div className="BenefitsDetails">
                                <span className="InvestTotal">Maturity amount</span>
                                <span className="InvestTotal">₹{CommaSeprator(decimaNumberFormat(QuoteData?.MaturityBenefit))}</span>
                            </div>
                            <div className="BenefitsDetails">
                                <span className="InvestTotal">Life Cover</span>
                                <span className="InvestTotal">₹{CommaSeprator(decimaNumberFormat(QuoteData?.DeathBenefit))}</span>
                            </div>
                            <hr />
                            <h3 className="InvestPopHead">Premium Breakup</h3>
                            <div className="BenefitsDetails">
                                <span className="InvestTotal">Base Premium</span>
                                <span className="InvestTotal">₹{CommaSeprator(decimaNumberFormat(QuoteData?.ModelPremium))}</span>
                            </div>
                            {isBeforeSep22_2025() && < div className="BenefitsDetails">
                                <span className="InvestTotal">GST  </span>
                                <span className="InvestTotal">+ ₹{CommaSeprator(decimaNumberFormat(QuoteData?.ServiceTax))}</span>
                            </div>}
                            <div className="BenefitsDetails">
                                <span className="InvestTotal"><strong>Total Premium</strong></span>
                                <span className="InvestTotal"><strong>₹{CommaSeprator(decimaNumberFormat(QuoteData?.TotalPremium))}</strong></span>
                            </div>
                            <div className="InvestDetailSubmit d-flex justify-content-center" onClick={() => { BuyNow(); setLoader(true) }}>
                                {/*<input type="submit" value="Invest Now" className="">
                                </input>*/}
                                {loader ? <span className=""><CircleLoader /> </span> : < span > Invest Now</span>}
                                </div>
                            </div>

                        <hr />

                        {/*  <div className="InvestDetailList AboutInsurer">
                                <ul>
                                    <li>
                                        <h4 className="mb-1 ListHead">About Insurer</h4>
                                        <p className="mb-3 ListPara">In 2000, HDFC Life began operating and has since become a prominent provider of long-term insurance solutions in India. It is a joint venture between Housing Development Finance Corporation Ltd (HDFC), a leading housing finance institution in India, and Standard Life Aberdeen plc, a global investment company. HDFC Life offers diverse plans to meet the varying needs of its customers.</p>
                                    </li>
                                </ul>
                            </div>*/}
                        {QuoteData?.ClaimSettlementRatio !== null && <h3 className="ClaimSettlement">Claims settlement ratio {QuoteData?.ClaimSettlementRatio}</h3>}
                    </section>

                </div>
            </div>
        </>
    );
}

export default InvestmentPlanDetalis;